module.exports = __webpack_public_path__ + "img/dodger-stadium_aerial.6009f9d2.jpg";